import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface FileItem {
  id: string;
  [key: string]: any;
}

interface FilesState {
  items: FileItem[];
  loading: boolean;
  error: string | null;
}

const initialState: FilesState = {
  items: [],
  loading: false,
  error: null,
};

const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    loadMoreFiles: (state, action: PayloadAction<{
      job_id: string;
      page: number;
      filter: string;
    }>) => {
      state.loading = true;
      state.error = null;
    },
    loadMoreFilesCommit: (state, action: PayloadAction<FileItem[]>) => {
      state.loading = false;
      state.items = concatAndDeDuplicateObjects('id', state.items, action.payload);
    },
    loadMoreFilesFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadMoreFiles,
  loadMoreFilesCommit,
  loadMoreFilesFailed,
} = filesSlice.actions;

export default filesSlice.reducer;